var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"msbox"},[_c('el-row',{staticClass:"row"},[_c('div',{staticClass:"hh"},_vm._l((_vm.docaudios),function(project){return _c('el-col',{key:project.infoId,attrs:{"span":25,"offset":1}},[_c('videos-list-itemtest',{staticClass:"now",attrs:{"videos-item":project}})],1)}),1)])],1),_c('bottom-bar',{staticClass:"bottom"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }